import React, { useState, useEffect } from 'react'
import './EditProduct.css'
import { useParams, useNavigate } from 'react-router-dom';
import { useProducts } from '../../../store/ProductContext';

function EditProduct() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { fetchProductById, updateProduct } = useProducts();

    const [formData, setFormData] = useState({
        title: '',
        category: 'Mobile',
        details: '',
        marketPrice: '',
        ourPrice: '',
        offer: '',
        stock: '',
        image1: '',
        image2: '',
        image3: '',
        deliveropt: 'Free',
        rating: '',
        totalOrders: 0
    });
    
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        const loadProduct = async () => {
            try {
                const product = await fetchProductById(id);
                if (product) {
                    setFormData({
                        title: product.title || '',
                        category: product.category || 'Mobile',
                        details: product.details || '',
                        marketPrice: product.pricing?.marketPrice || '',
                        ourPrice: product.pricing?.ourPrice || '',
                        offer: product.pricing?.offer || '',
                        stock: product.stock || '',
                        image1: product.imageUrls?.imageUrl1 || '',
                        image2: product.imageUrls?.imageUrl2 || '',
                        image3: product.imageUrls?.imageUrl3 || '',
                        deliveropt: product.deliveryOption || 'Free',
                        rating: product.rating || '',
                        totalOrders: product.totalOrders || 0
                    });
                }
            } catch (error) {
                console.error('Error loading product:', error);
            }
        };

        if (id) {
            loadProduct();
        }
    }, [id, fetchProductById]);

    useEffect(() => {
        if (formData.marketPrice && formData.ourPrice) {
            const mp = parseFloat(formData.marketPrice);
            const op = parseFloat(formData.ourPrice);
            const off = ((mp - op) / mp) * 100;
            setFormData(prev => ({
                ...prev,
                offer: off.toFixed(2)
            }));
        }
    }, [formData.marketPrice, formData.ourPrice]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const updatedProduct = {
                title: formData.title,
                category: formData.category,
                pricing: {
                    marketPrice: parseFloat(formData.marketPrice),
                    ourPrice: parseFloat(formData.ourPrice),
                    offer: parseFloat(formData.offer)
                },
                rating: formData.rating,
                stock: formData.stock,
                details: formData.details,
                deliveryOption: formData.deliveropt,
                imageUrls: {
                    imageUrl1: formData.image1,
                    imageUrl2: formData.image2,
                    imageUrl3: formData.image3
                },
                totalOrders: parseInt(formData.totalOrders)
            };

            await updateProduct(id, updatedProduct);
            alert('Product updated successfully!');
            navigate('/admin-home');
        } catch (err) {
            alert('Error updating product: ' + err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="product-form-container">
            <div className="product-form-card">
                <h2 className="form-header">Edit Product</h2>
                <form onSubmit={handleSubmit} className="product-form">
                    <div className="form-section">
                        <div className="form-group">
                            <label htmlFor="title">Product Title</label>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="category">Category</label>
                            <select
                                name="category"
                                id="category"
                                value={formData.category}
                                onChange={handleChange}
                            >
                                <option value="Mobile">Mobile</option>
                                <option value="Laptop">Laptop</option>
                                <option value="Tablet">Tablet</option>
                                <option value="Cloth">Cloth</option>
                                <option value="Watch">Watch</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="details">Product Details</label>
                            <textarea
                                id="details"
                                name="details"
                                value={formData.details}
                                onChange={handleChange}
                                rows="3"
                            />
                        </div>
                    </div>

                    <div className="form-section">
                        <div className="price-group">
                            <div className="form-group">
                                <label htmlFor="marketPrice">Market Price</label>
                                <input
                                    type="number"
                                    id="marketPrice"
                                    name="marketPrice"
                                    value={formData.marketPrice}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="ourPrice">Our Price</label>
                                <input
                                    type="number"
                                    id="ourPrice"
                                    name="ourPrice"
                                    value={formData.ourPrice}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="offer">Offer (%)</label>
                                <input
                                    type="number"
                                    id="offer"
                                    name="offer"
                                    value={formData.offer}
                                    readOnly
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="stock">Stock</label>
                                <input
                                    type="number"
                                    id="stock"
                                    name="stock"
                                    value={formData.stock}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="rating">Rating (1-5 stars)</label>
                            <input
                                type="number"
                                id="rating"
                                name="rating"
                                value={formData.rating}
                                onChange={handleChange}
                                min="1"
                                max="5"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="deliveropt">Delivery Option</label>
                            <select
                                id="deliveropt"
                                name="deliveropt"
                                value={formData.deliveropt}
                                onChange={handleChange}
                            >
                                <option value="Free">Free Delivery</option>
                                <option value="Paid">Paid Delivery</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-section">
                        <div className="form-group">
                            <label>Product Images</label>
                            <input
                                type="text"
                                placeholder="Image URL 1"
                                name="image1"
                                value={formData.image1}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                placeholder="Image URL 2"
                                name="image2"
                                value={formData.image2}
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                placeholder="Image URL 3"
                                name="image3"
                                value={formData.image3}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="image-previews">
                            {formData.image1 && (
                                <div className="image-preview">
                                    <img src={formData.image1} alt="Product preview 1" />
                                </div>
                            )}
                            {formData.image2 && (
                                <div className="image-preview">
                                    <img src={formData.image2} alt="Product preview 2" />
                                </div>
                            )}
                            {formData.image3 && (
                                <div className="image-preview">
                                    <img src={formData.image3} alt="Product preview 3" />
                                </div>
                            )}
                        </div>
                    </div>

                    <button type="submit" className="submit-button" disabled={isSubmitting}>
                        {isSubmitting ? 'Updating...' : 'Update Product'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default EditProduct;